import { render, staticRenderFns } from "./LayoutNtrPaslaugos.vue?vue&type=template&id=40f2ce60&scoped=true&"
import script from "./LayoutNtrPaslaugos.vue?vue&type=script&lang=js&"
export * from "./LayoutNtrPaslaugos.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNtrPaslaugos.vue?vue&type=style&index=0&id=40f2ce60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2ce60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VApp,VMain,VSheet})
